import React, { JSX } from 'react';
import Card from 'src/components/Card';
import Metrics from 'src/components/Metrics';
import Skeleton from 'src/components/Skeleton/Skeleton';

const WARRANTY_ROW_COUNT: number = 4;

const WarrantyDetailsSkeleton = () => {
  const rowStyle = {
    paddingTop: 5,
    paddingBottom: 5,
    display: 'grid' as const,
  };

  return (
    <>
      <Metrics title="warranty details" items={[]} />
      {Array.from({ length: WARRANTY_ROW_COUNT }, (_, index: number) => (
        <div key={`warranty-skel-${index}`} className="metrics__key" style={rowStyle}>
          <Skeleton variant="text" width="70%" />
        </div>
      ))}
    </>
  );
};

const ServiceRequestMetricsSkeleton = () => (
  <Card
    title="Service Requests"
    body={
      <div className="metrics">
        <div className="metrics__items">
          {['Active', 'Closed'].map((label: string) => (
            <div key={label} className="metrics__item">
              <div className="metrics__value">
                <Skeleton variant="text" width="2rem" />
              </div>
              <div className="metrics__key">{label}</div>
            </div>
          ))}
        </div>
      </div>
    }
  />
);

// Built as an array of JSX elements so the parent's `HeadingWithDetails`
// items prop receives the same shape it gets from SuiteDetailsComponents.
export const buildSuiteDetailsSkeleton = (): JSX.Element[] => [
  <WarrantyDetailsSkeleton key="warranty-skeleton" />,
  <ServiceRequestMetricsSkeleton key="sr-metrics-skeleton" />,
];
